document.addEventListener("DOMContentLoaded", () => {
    ;(function initMobileHeader() {
        const mobHeaderContainer = document.querySelector(".riverty-mobile-header-container")
        const afsBanner = document.querySelector(".afs-banner")
        let isIOS =
            (/iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)) &&
            !window.MSStream

        var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)

        // Edge (based on chromium) detection
        var isEdgeChromium = isChrome && navigator.userAgent.indexOf("Edg") != -1

        if (mobHeaderContainer) {
            if (isIOS && !navigator.userAgent.match("CriOS")) {
                mobHeaderContainer.classList.add("ios")
            }
            if (isIOS && navigator.userAgent.match("CriOS")) {
                mobHeaderContainer.classList.add("crios")
            }
            const overlay = document.querySelector(".riverty-header-overlay")
            const mobileHeader = mobHeaderContainer.querySelector(".riverty-header-mobile")
            let windowWidth = window.innerWidth
            const body = document.body
            const main = document.querySelector(".main")

            function setHeaderHeight(height = 0) {
                if (mobileHeader && main) {
                    let bottom = !height ? mobileHeader.getBoundingClientRect().bottom : height
                    if (windowWidth <= 1024) {
                        document.documentElement.style.setProperty("--header-offset-top", Math.floor(bottom) + "px")
                        main.classList.add("under-mobile-header")
                    } else {
                        document.documentElement.style.setProperty("--header-offset-top", 0)
                        main.classList.remove("under-mobile-header")
                    }
                }
            }

            setHeaderHeight()

            function setMobileHeaderPos(manipulation = false) {
                if (mobileHeader) {
                    if (afsBanner && !afsBanner.classList.contains("hidden")) {
                        if (isIOS && !manipulation) {
                            mobileHeader.style.top = `${afsBanner.clientHeight + 20}px`
                        } else {
                            mobileHeader.style.top = `${afsBanner.clientHeight}px`
                        }
                    } else {
                        mobileHeader.style.top = 0
                    }
                }
            }

            setMobileHeaderPos()

            function afsBannerClose(e) {
                if (e.target.closest(".afs-banner__close-btn")) {
                    const mobileHeaderHeight = mobileHeader.clientHeight
                    setHeaderHeight(mobileHeaderHeight)
                }
            }

            document.addEventListener("click", afsBannerClose)

            if (mobHeaderContainer) {
                const burger = mobHeaderContainer.querySelector(".riverty-burger")
                const menu = mobHeaderContainer.querySelector(".riverty-mobile-nav-container")
                const slider = mobHeaderContainer.querySelector(".riverty-mobile-nav-slider")
                const sliderList = slider.querySelector(".riverty-mobile-nav-slider-list")
                const links = mobHeaderContainer.querySelectorAll(".riverty-mobile-nav-slider .riverty-mobile-nav-slider-link")
                let currentLink = mobHeaderContainer.querySelector(".riverty-mobile-nav-slider .riverty-mobile-nav-slider-link.active")

                const navHeaders = mobHeaderContainer.querySelectorAll(".riverty-mobile-nav-header")
                const navBodies = mobHeaderContainer.querySelectorAll(".riverty-mobile-nav-body")
                const navFooters = mobHeaderContainer.querySelectorAll(".riverty-mobile-nav-footer")

                let currentNavHeader, currentNavBody, currentNavFooter, thirdNav, thirdNavBody, currentDropdown

                const getCurrentPart = (node, string) => {
                    return [...node].find((item) => {
                        return item.dataset[string] === currentLink.dataset.link
                    })
                }

                const setupCtaPos = () => {
                    const visibleBody = document.querySelector(".riverty-mobile-nav-body.visible")
                    if (visibleBody) {
                        const ctaBlock = visibleBody.querySelector(".riverty-mobile-nav-footer")
                        if (isIOS) {
                            ctaBlock.style.top = `${visibleBody.clientHeight}px`
                        } else {
                            ctaBlock.style.top = `${visibleBody.clientHeight + 21}px`
                        }
                    }
                }

                const showParts = () => {
                    currentNavHeader = getCurrentPart(navHeaders, "header")
                    currentNavBody = getCurrentPart(navBodies, "body")
                    currentNavFooter = getCurrentPart(navFooters, "footer")
                    currentNavHeader.classList.add("visible")
                    if (menu.classList.contains("active")) {
                        currentNavFooter.classList.add("visible")
                    }
                    currentNavBody.classList.add("visible")
                    thirdNav = currentNavBody.querySelector(".riverty-third-level-nav")
                    thirdNavBody = thirdNav.querySelector(".riverty-third-level-nav-body")
                    // setupCtaPos()
                }

                const checkCurrentLink = () => {
                    if (currentLink.classList.contains("riverty-mobile-nav-slider-link--business")) {
                        mobHeaderContainer.classList.add("dark")
                    } else {
                        mobHeaderContainer.classList.remove("dark")
                    }
                }

                checkCurrentLink()

                const openMenu = (e) => {
                    e.preventDefault()
                    mobHeaderContainer.classList.add("active")
                    if (afsBanner && !afsBanner.classList.contains("hidden")) {
                        mobileHeader.style.top = `${afsBanner.clientHeight}px`
                    }
                    menu.classList.add("active")
                    overlay.classList.add("active")
                    body.classList.add("scroll-disabled")
                    showParts()
                }

                let touchstartX = 0
                let touchendX = 0
                let isSwipedToRight = false

                const checkDirection = () => {
                    if (touchendX < touchstartX) isSwipedToRight = false
                    if (touchendX > touchstartX + 200) isSwipedToRight = true
                }

                const closeMenu = (e) => {
                    if (
                        e?.target.closest(".riverty-mobile-nav-close-btn") ||
                        e?.target.closest(".riverty-header-overlay") ||
                        isSwipedToRight
                    ) {
                        e?.preventDefault()
                        mobHeaderContainer.classList.remove("active")
                        menu.classList.remove("active")
                        overlay.classList.remove("active")
                        body.classList.remove("scroll-disabled")
                        navFooters.forEach((footer) => {
                            footer.classList.remove("visible")
                        })
                        currentNavFooter.classList.remove("no-animations")
                        isSwipedToRight = false
                    }
                }

                document.addEventListener("touchstart", (e) => {
                    touchstartX = e.changedTouches[0].screenX
                })

                document.addEventListener("touchmove", (e) => {
                    touchendX = e.changedTouches[0].screenX
                    checkDirection()
                    closeMenu()
                })

                let lastSlide

                const hideParts = () => {
                    navHeaders.forEach((header) => {
                        header.classList.remove("visible")
                    })

                    navBodies.forEach((body) => {
                        body.classList.remove("visible")
                    })
                }

                const switchSlides = (e) => {
                    if (e.target.closest("[data-link]")) {
                        lastSlide = e.target.closest("[data-link]")
                        e.preventDefault()
                        links.forEach((item) => {
                            item.classList.remove("active")
                        })
                        currentLink = e.target.closest("[data-link]")
                        currentLink.classList.add("active")
                        hideParts()
                        navFooters.forEach((footer) => {
                            footer.classList.remove("visible")
                        })
                        showParts()
                        checkCurrentLink()
                        currentNavFooter.classList.add("no-animations")
                    } else {
                        if (lastSlide) {
                            // showParts()
                        }
                    }
                }

                burger.addEventListener("click", openMenu)

                document.addEventListener("click", closeMenu)

                slider.addEventListener("click", switchSlides)

                const toggleDropdown = (e) => {
                    if (e.target.closest(".riverty-mobile-dropdown-link")) {
                        const activeDdLink = e.target.closest(".riverty-mobile-dropdown-link")

                        if (activeDdLink.nextElementSibling) {
                            e.preventDefault()
                        }
                        activeDdLink.classList.toggle("active")
                    }
                }

                document.addEventListener("click", toggleDropdown)

                const openThirdLevelMenu = (e) => {
                    if (e.target.closest(".third-level-link")) {
                        e.preventDefault()
                        const currentLink = e.target.closest(".third-level-link")
                        const linkTitle = currentLink.querySelector(".riverty-mobile-main-info")
                        const linkBody = currentLink.nextElementSibling ?? currentLink.nextElementSibling
                        const thirdNavTitle = thirdNav.querySelector(".riverty-third-level-nav-header__title")
                        currentDropdown = currentNavBody.querySelector(".riverty-mobile-dropdown")

                        thirdNavTitle.innerHTML = linkTitle.innerHTML
                        thirdNavBody.innerHTML = ""
                        thirdNavBody.insertAdjacentHTML("beforeend", linkBody.outerHTML)
                        currentNavBody.classList.add("third-level-nav-opened")
                        thirdNav.classList.add("visible")
                        currentDropdown.classList.add("hidden")
                    }
                }

                document.addEventListener("click", openThirdLevelMenu)

                const closeThirdLevelMenu = (e) => {
                    if (e.target.closest(".riverty-third-level-nav-link")) {
                        e.preventDefault()
                        thirdNav.classList.remove("visible")
                        thirdNavBody.innerHTML = ""
                        currentDropdown.classList.remove("hidden")
                        currentNavBody.classList.remove("third-level-nav-opened")
                    }
                }

                document.addEventListener("click", closeThirdLevelMenu)
            }

            window.addEventListener("resize", () => {
                windowWidth = window.innerWidth
                setMobileHeaderPos(true)
            })

            if (isIOS) {
                window.addEventListener("scroll", () => {
                    setMobileHeaderPos(true)
                })
            }
        }
    })()

    function initHeader() {
        const header = document.querySelector(".riverty-header")
        const subNav = document.querySelector(".riverty-sub-nav")
        const subNavContainer = document.querySelector(".riverty-sub-nav-container")
        if (header && subNav) {
            const afsBanner = document.querySelector(".afs-banner")
            const listItems = subNav.querySelectorAll(".riverty-sub-nav-item")
            const initialyActiveLink = header.querySelector(".riverty-header-nav-link.active")
            const headerLinks = header.querySelectorAll(".riverty-header-nav-link")
            const overlay = document.querySelector(".riverty-header-overlay")

            const adjustSearchTab = () => {
                const searchTab = document.querySelector(".riverty-header-search")
                const headerNav = header.querySelector(".riverty-header-nav")
                if (searchTab && headerNav) {
                    searchTab.style.maxWidth = `${headerNav.clientWidth}px`
                }
            }

            adjustSearchTab()

            const switchHeaderColor = (e) => {
                ;[...headerLinks].forEach((item) => {
                    item.classList.remove("hovered")
                })
                const hoveredLink = e.target.closest(".riverty-header-nav-link:not(.active)")

                const manipulateHoverLink = () => {
                    if (hoveredLink) {
                        hoveredLink.classList.add("hovered")
                        if (initialyActiveLink) initialyActiveLink.classList?.remove("active")
                        if (hoveredLink.classList.contains("riverty-header-nav-link--consumer")) {
                            header.classList.remove("dark")
                        } else {
                            header.classList.add("dark")
                        }
                    } else {
                        if (initialyActiveLink) initialyActiveLink.classList.add("active")
                        if (header.classList.contains("business")) {
                            header.classList.add("dark")
                        }
                    }
                }

                manipulateHoverLink()

                if (e.target.closest(".riverty-header-search")) {
                    header.classList.add("search-hovered")
                } else {
                    header.classList.remove("search-hovered")
                }
            }

            const openFlyout = (e) => {
                const currentItem = e.target.closest(".riverty-sub-nav-item")
                if (currentItem) {
                    if (e.code === "Enter") {
                        const navLink = currentItem.querySelector(".riverty-sub-nav-link")

                        if (navLink && navLink.href && navLink.getAttribute("href") !== "#") {
                            return
                        }
                    }

                    ;[...listItems].forEach((item) => {
                        item.classList.remove("active")
                    })
                    currentItem?.classList.add("active")
                    if (currentItem.querySelector(".riverty-header-flyout")) {
                        // const currentFlyout = currentItem.querySelector(".riverty-header-flyout")
                        // currentFlyout.style.top = `${subNav.clientHeight}px`
                        overlay.classList.add("active")
                    } else {
                        overlay.classList.remove("active")
                    }
                }
            }

            const closeFlyout = (e) => {
                if (!e.target.closest(".riverty-sub-nav")) {
                    ;[...listItems].forEach((item) => {
                        item.classList.remove("active")
                    })
                    overlay.classList.remove("active")
                }
            }

            const returnActiveState = (e) => {
                if (e.target.closest(".riverty-header-nav-link") && initialyActiveLink) {
                    initialyActiveLink?.classList.add("active")
                }

                ;[...headerLinks].forEach((item) => {
                    item.classList.remove("hovered")
                })

                if (!header.classList.contains("business")) {
                    header.classList.remove("dark")
                } else {
                    header.classList.add("dark")
                }
            }
            header.addEventListener("mousemove", switchHeaderColor)
            document.addEventListener("mouseout", returnActiveState)
            subNav.addEventListener("mouseover", openFlyout)
            subNav.addEventListener("keydown", (e) => {
                if (e.code === "Enter") {
                    openFlyout(e)
                }
            })
            document.addEventListener("mousemove", closeFlyout)

            if (afsBanner && !afsBanner.classList.contains("hidden") && window.innerWidth > 1025) {
                subNavContainer.style.top = `${afsBanner.clientHeight}px`
            } else {
                subNavContainer.style.top = 0
            }

            document.addEventListener("click", (e) => {
                if (e.target.closest(".afs-banner__close-btn")) {
                    subNavContainer.style.top = 0
                }
            })
        }
    }

    const invokeHeader = () => {
        if (window.innerWidth > 1025) {
            initHeader()
        }
    }

    invokeHeader()

    const initDistHeader = () => {
        const distHeader = document.querySelector(".riverty-distribution-header")
        if (distHeader) {
            let bottom = distHeader.getBoundingClientRect().bottom
            document.documentElement.style.setProperty("--header-offset-top", Math.floor(bottom) + "px")
        }
    }
    initDistHeader()

    window.addEventListener("resize", invokeHeader)
})
